const s = {
  xs: "max-w-[20vw]",
  sm: "max-w-[35vw]",
  md: "max-w-[50vw]",
  lg: "max-w-[85vw]"
}, t = (e) => e ? `text-${e}` : "text-lg", a = (e) => {
  switch (e) {
    case "sm":
    case "base":
      return 20;
    case "md":
    case "lg":
    default:
      return 28;
  }
};
export {
  a as getCloseIconSize,
  t as getTitleSize,
  s as sizeClasses
};
